class SearchSuggest {

  

    removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        $(x).removeClass("autocomplete-active");
    }

    addActive(x, self) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        self.removeActive(x);
        if (self.currentFocus >= x.length) self.currentFocus = 0;
        if (self.currentFocus < 0) self.currentFocus = (x.length - 1);
        /*add class "autocomplete-active":*/
        $(x[self.currentFocus]).addClass("autocomplete-active");
    }

    loadSuggestions(searchtext, inputElem) {
        this.loadInProgress = true;
        const self = this;
        var url = '/api/search/suggest?query={keyword}&lang={lang}'.replace('{keyword}', searchtext).replace('{lang}', this.searchLang);
        this.currentFocus = -1;
        var divElem = $(this.searchInput).closest('.search-panel');
        this.controller = new AbortController();
        var searchPromise = fetch(url, {signal: this.controller.signal});
        searchPromise.then(function (result) {
            var resultStreamPromise = result.json();
            resultStreamPromise.then(function (searchResult) {
                if (searchResult && searchResult.length > 0) {
                    var a = document.createElement("ul");
                    a.setAttribute("id", self.searchInput.id + "_" + "search-result__suggestions");
                    a.setAttribute("class", "search-result__suggestions");
                    self.currentList = divElem.append(a);
                    searchResult.forEach(function (item) {
                        var b = document.createElement("li");
                        var idx = item.toUpperCase().indexOf(searchtext.toUpperCase())
                        if (idx > -1) {
                            b.innerHTML = item.substr(0, idx);
                            b.innerHTML += "<strong>" + item.substr(idx, searchtext.length) + "</strong>";
                            b.innerHTML += item.substr(searchtext.length + idx);
                        } else {
                            b.innerHTML = item;
                        }
                        b.addEventListener("click", function (e) {
                            inputElem.value = item;
                            self.currentFocus = -1;
                            self.currentList = null;
                            self.closeAllLists();
                            $(inputElem).addClass('has-value');
                            $(inputElem).closest('form').submit();
                        });
                        a.append(b);
                        //console.log(item);
                    });
                }

            });
        }).finally(function () { self.loadInProgress = false; });
    }

    
    constructor() {
        this.loadInProgress = false;
        this.searchInputs = $('.search-input'); //All search inputs
        this.searchLang = $(this.searchInputs).attr('data-lang'); //Current search language
        this.searchInput = null; //Current search input
        this.controller = new AbortController();
        this.currentFocus = -1;
        this.currentList = null;
        if (this.searchInputs) {
            const self = this;
            this.searchInputs.on('input', function (e) {
                if (self.loadInProgress) {
                    self.controller.abort();
                }
                self.searchInput = e.target;
                self.closeAllLists();
                var val = e.target.value;
                if (val.length >= 1 && !self.loadInProgress) {
                    e.target.classList.add("has-value");
                    self.loadSuggestions(val, e.target);
                }

            });
            //this.searchInputs.on("focusout", function (e) {
            //    self.searchInput = e.target;
            //    window.setTimeout(1000, function () { self.closeAllLists(); });
            //});
            this.searchInputs.on("keydown", function (e) {
                self.searchInput = e.target;
                var x = $(".search-result__suggestions").find("li");
                if (e.keyCode == 40) {
                    /*If the arrow DOWN key is pressed,
                    increase the currentFocus variable:*/
                    self.currentFocus++;
                    /*and and make the current item more visible:*/
                    self.addActive(x,self);
                } else if (e.keyCode == 38) { //up
                    /*If the arrow UP key is pressed,
                    decrease the currentFocus variable:*/
                    self.currentFocus--;
                    /*and and make the current item more visible:*/
                    self.addActive(x,self);
                } else if (e.keyCode == 13) {
                    //!TODO: Only preventDefault if we are on an item in autocomplete
                    /*If the ENTER key is pressed, prevent the form from being submitted,*/
                    if (self.currentFocus > -1) {
                        e.preventDefault();
                        if (x) x[self.currentFocus].click();
                    }
                    self.searchInput.closest('form').submit();
                }
            });

        }
    }


    closeAllLists(elmnt) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName("search-result__suggestions");
        for (var i = 0; i < x.length; i++) {
            if (elmnt != x[i] && elmnt != this.searchInput) {
                $(this.searchInput).removeClass("has-value");
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }
    
}
export default SearchSuggest;